import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAccordion, FDAccordionDetails, FDAccordionGroup, FDAccordionTitle, FDBodyText, FDPaper,
} from '@facet-wealth/design';
import LogDifferencesWrapper
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Content/LogsPicker/LogsContainer/Logs/LogDifferences';

const ChangesAccordionGroup = ({ collection, title }) => {
  if (collection.resources().length() === 0) {
    return null;
  }

  const changeDetails = collection.resources().list().map((resource) => {
    return (
      <FDAccordion expansionID={resource.id()}>
        <FDAccordionTitle>
          <FDBodyText value={resource.attr('eventName')} />
        </FDAccordionTitle>
        <FDAccordionDetails>
          <LogDifferencesWrapper resource={resource} />
        </FDAccordionDetails>
      </FDAccordion>
    );
  });

  return (
    <FDPaper padding="100" width={500}>
      <FDAccordionGroup>
        <FDAccordion expansionID={title}>
          <FDAccordionTitle>
            <FDBodyText value={title} />
          </FDAccordionTitle>
          <FDAccordionDetails>
            <FDAccordionGroup>
              {changeDetails}
            </FDAccordionGroup>
          </FDAccordionDetails>
        </FDAccordion>
      </FDAccordionGroup>
    </FDPaper>
  );
};

ChangesAccordionGroup.defaultProps = {};

ChangesAccordionGroup.propTypes = {
  collection: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default ChangesAccordionGroup;
